export const experiences = [{
        location: "JTV Media | Gawe Data",
        position: "UI UX Designer Internship",
        time: "Sept’22 - Nov’22",
    },
    {
        location: "DTS Kominfo | FGA",
        position: "Primavera P6 Professional Project Management Fundamental",
        time: "Jul’22 - Aug’22",
    },
    {
        location: "Studi Independent",
        position: "UI UX Lead Designer at Final Project",
        time: "Feb’22 - July’22",
    },
    {
        location: "Computer Lab Admin",
        position: "Departement of Information System",
        time: "Mar’22 - Now",
    },
    {
        location: "UKM-FT ITC",
        position: "Head of Education and Curriculum Division",
        time: "Mar’21 - Des’21",
    },
    {
        location: "DTS Kominfo",
        position: "Intro To Full Stack Developer Website",
        time: "Mei’21 - Jun’21",
    },
    {
        location: "Lab Assistant | UTM",
        position: "Department of Information System",
        time: "2020 - Now",
    },
];